import { render, staticRenderFns } from "./CheckForm.vue?vue&type=template&id=dc2180ae&scoped=true&"
import script from "./CheckForm.vue?vue&type=script&lang=js&"
export * from "./CheckForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2180ae",
  null
  
)

export default component.exports